import {
  FIELD_LABEL_ACTIVITY,
  FIELD_LABEL_PERFORMED_BY,
  FIELD_LABEL_MADE_ON,
  DEFAULT_ACTIVITY_VALUE,
} from "../../../constants/fileManagement.constants";
import { formatDate } from "../../../utils/fileManagement.utils";
import type { FileDetailsFileHistoryProps } from "../../../types/fileManagement.types";

const FileDetailsFileHistory = ({
  performedBy,
  madeOn,
}: FileDetailsFileHistoryProps) => {
  return (
    <div className="flex flex-col gap-4 pb-[30px] pt-2.5">
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_ACTIVITY}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {DEFAULT_ACTIVITY_VALUE}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_PERFORMED_BY}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {performedBy}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_MADE_ON}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {formatDate(madeOn)}
        </span>
      </div>
    </div>
  );
};

export default FileDetailsFileHistory;
